import { Injectable, ResourceRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ResourceStateService {
  private readonly _lastKnown = new WeakMap<object, unknown>();

  valueOf<T>(resource: ResourceRef<T | undefined>): T | undefined {
    if (resource.hasValue()) {
      const value = resource.value();
      this._lastKnown.set(resource, value);

      return value;
    }

    // Angular drops the stream when a request signal changes, so without this every list
    // blanks to zero rows on each filter, sort and page change.
    if (resource.status() === 'loading') {
      return this._lastKnown.get(resource) as T | undefined;
    }

    return undefined;
  }
}
